import { userConstants } from "../constants/login.constants";

 function annualStatement(state = {}, action) {
    switch (action.type) {
        case userConstants.ANNUALSTATEMENT_REQUEST:
            return {
                loading: true
            };
        case userConstants.ANNUALSTATEMENT_SUCCESS:
            return {
                items: action.annualStatement
            };
        case userConstants.ANNUALSTATEMENT_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}
export default annualStatement;